import {
  setCookie as setCookieHandler,
  getCookie as getCookieHandler,
  removeCookie as removeCookieHandler,
  itemType,
} from 'MMT-UI/storages/client/cookieStorage';

export function getExpiryTime(noOfMilliseconds) {
  const d = new Date();
  // d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  d.setTime(d.getTime() + noOfMilliseconds);
  const expires = d.toUTCString();
  return new Date(expires);
}

export function setCookie(key, value, maxAgeInMilliseconds, isEssential, shouldStringifyJson = false) {
  const type = isEssential ? itemType.ES : itemType.N_ES;
  setCookieHandler(
    key,
    value,
    {
      path: '/',
      domain: '.makemytrip.com',
      ...(maxAgeInMilliseconds
        ? { expiresVal: getExpiryTime(maxAgeInMilliseconds) }
        : {}),
      shouldStringifyJson,
    },
    type,
  );
}

export function getCookie(key, isEssential) {
  const type = isEssential ? itemType.ES : itemType.N_ES;
  return getCookieHandler(key, { shouldParseJson: true }, type);
}

export function removeCookie(key) {
  return removeCookieHandler(key, { path: "/", domain: ".makemytrip.com" });
}

export function getFontUrl(language, isGoibibo = false) {
  if (isGoibibo) {
    return "https://fonts.googleapis.com/css?family=Rubik:300,400,500,400i,700,900&display=swap";
  }

  if (language === "ar") {
    return "https://fonts.googleapis.com/css2?family=Almarai:wght@300;400;700&display=swap";
  }

  return "https://fonts.googleapis.com/css?family=Lato:300,400,500,400i,700,900&display=swap";
}

export function addRuppeSymbol(str) {
  return str ? `₹${str}` : "";
}
